const initialData = {
    user: {}
};

const userReducers = (state = initialData, action) => {
    switch (action.type) {
        case "USER_DATA":
            const { data } = action.payload;
            return {
                ...state,
                user: data
            };
        default:
            return state; // Explicitly return the current state for unknown actions
    }
};

export default userReducers;
